export const sourcesData = [
  {
    key: "1",
    title: "Phone Calls",
    createdAt: "25 Sep 2023, 01:22 pm",
    status: "Active",
  },
  {
    key: "2",
    title: "Social Media",
    createdAt: "29 Sep 2023, 04:15 pm",
    status: "Active",
  },
  {
    key: "3",
    title: "Referral Sites",
    createdAt: "04 Oct 2023, 10:18 am",
    status: "Active",
  },
  {
    key: "4",
    title: "Web Analytics",
    createdAt: "17 Oct 2023, 03:31 pm",
    status: "Inactive",
  },
  {
    key: "5",
    title: "Previous Purchases",
    createdAt: "24 Oct 2023, 09:14 pm",
    status: "Active",
  },
  {
    key: "6",
    title: "Lead & Opportunity",
    createdAt: "08 Nov 2023, 09:56 am",
    status: "Active",
  },
  {
    key: "7",
    title: "Image-based Features",
    createdAt: "14 Nov 2023, 04:19 pm",
    status: "Active",
  },
  {
    key: "8",
    title: "Bots",
    createdAt: "23 Nov 2023, 11:14 pm",
    status: "Active",
  },
  {
    key: "9",
    title: "Insights",
    createdAt: "10 Dec 2023, 06:43 am",
    status: "Active",
  },
  {
    key: "10",
    title: "Commerce",
    createdAt: "25 Dec 2023, 08:17 pm",
    status: "Active",
  },
];
